// Delegate — the headless hook moved to `@heidi/workspace/data` (D2,
// ARCFE-1062). This file owns the app reactions (ARCFE-921): the destructive
// toast and the COMPOSITE `invalidateCurrentUser()` (GET_USER *and* the commerce
// GET_PRODUCTS behind one try/catch).
//
// `PendingSubStep` stays DECLARED here rather than moving: it references `Page`
// from `@/hooks/useTutorial`, an app module the package cannot import. The
// package hook takes the contracts' schema-derived `PendingSubStep`, which D1
// (ARCFE-1037) already established is structurally identical — so this type
// remains assignable to it and no caller changes.
import { toast } from '@heidi/design-system/toast';
import { type TutorialSteps } from '@heidi/schema/ml-scribe';
import { useMutateUpdateUserOnboardingSubTask as useMutateUpdateUserOnboardingSubTaskCore } from '@heidi/workspace/data';
import { invalidateCurrentUser } from '../query/useQueryUser';
import { type Page } from '../useTutorial';

export type PendingSubStep = {
  step: TutorialSteps | null;
  page: Page | null;
};

export function useMutateUpdateUserOnboardingSubTask() {
  return useMutateUpdateUserOnboardingSubTaskCore({
    onOnboardingSubTaskUpdated: () => {
      void invalidateCurrentUser();
    },
    onOnboardingSubTaskError: (error) => {
      toast({
        tone: 'destructive',
        title: 'Failed to update user onboarding sub task',
        description: error.message,
      });
    },
  });
}
